import {useMemo} from "react";
import DashCard from "../../../../../components/dash-card/dash-card.jsx";
import MetricDashCard from "../../../../../components/dash-card/metric-dash-card.jsx";
import SentryEchart from "../../../../../components/echarts/sentry-echart.jsx";
import useGraphViewportWidth from "../../../../../hooks/use-graph-viewport-width.js";
import {fluidPx} from "../../../../../utils/responsive-graph.js";

export default function AccompanimentCard({ accompaniment }) {
    const vw = useGraphViewportWidth();
    const sourceItems = accompaniment?.topTrackingNatures;

    const topTrackingNaturesChart = useMemo(() => {
        const topTrackingNatures = Array.isArray(sourceItems)
            ? sourceItems
                .map(item => ({
                    label: item.label ?? "",
                    value: Number(item.qty) || 0,
                }))
                .sort((firstItem, secondItem) => secondItem.value - firstItem.value)
                .slice(0, 3)
            : [];
        const labelFs = fluidPx(12, 21, vw);
        const valueFs = fluidPx(14, 20, vw);
        const max = Math.max(...topTrackingNatures.map(item => item.value), 1);
        const values = Array.from({length: 3}, (_, index) => topTrackingNatures[index]?.value ?? 0);
        const labels = Array.from({length: 3}, (_, index) => topTrackingNatures[index]?.label ?? "");

        return {
            grid: {
                top: labelFs + 17,
                left: "4%",
                right: "12%",
                bottom: 4,
                outerBounds: {
                    top: labelFs + 17,
                    left: "4%",
                    right: "12%",
                    bottom: 4,
                },
                outerBoundsContain: "axisLabel"
            },
            tooltip: {
                show: true,
                appendToBody: true,
                confine: false,
                extraCssText: "max-width: 320px; white-space: normal;"
            },
            xAxis: {
                type: "value",
                max,
                show: false,
            },
            yAxis: {
                type: "category",
                data: labels,
                inverse: true,
                axisLabel: {show: false},
                axisLine: {show: false},
                axisTick: {show: false}
            },
            series: [
                {
                    type: "bar",
                    barWidth: "35%",
                    barCategoryGap: "24%",
                    itemStyle: {
                        color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 1,
                            y2: 0,
                            colorStops: [
                                {offset: 0, color: "#003878"},
                                {offset: 0.28, color: "#0080ED"},
                                {offset: 0.52, color: "#1CEAE6"},
                                {offset: 0.72, color: "#3E98D9"},
                                {offset: 1, color: "#003878"}
                            ]
                        },
                        borderRadius: 20
                    },
                    label: {
                        show: true,
                        position: [0, -4],
                        align: "left",
                        verticalAlign: "bottom",
                        color: "#AAAAAA",
                        fontSize: labelFs,
                        fontWeight: 400,
                        formatter: params => labels[params.dataIndex]
                    },
                    showBackground: true,
                    backgroundStyle: {
                        color: "#3C3C4A",
                        borderRadius: 12
                    },
                    data: values
                },
                {
                    type: "bar",
                    barWidth: "35%",
                    barCategoryGap: "24%",
                    barGap: "-100%",
                    silent: true,
                    tooltip: {show: false},
                    itemStyle: {
                        color: "transparent"
                    },
                    label: {
                        show: true,
                        position: "right",
                        distance: 5,
                        color: "#FFFFFF",
                        fontSize: valueFs,
                        fontWeight: 600,
                        formatter: params => labels[params.dataIndex] === ""
                            ? ""
                            : values[params.dataIndex]
                    },
                    data: values.map(() => max)
                }
            ]
        };
    }, [sourceItems, vw]);

    return (
        <DashCard
            width="100%"
            height="100%"
            className="col-span-10 min-h-0 h-full"
        >
            <section className="h-full w-full min-h-0 items-center flex flex-col gap-3 pt-4">
                <MetricDashCard
                    counterCard
                    title="Acompanhamentos"
                    value={accompaniment?.eventTracking ?? 0}
                    width="auto"
                    height="auto"
                    dashClassName="min-h-[76px] min-w-[197px] px-3! shrink-0"
                />
                <article className="flex-1 w-full min-w-0 min-h-0 flex flex-col">
                    <h3 className="shrink-0 px-4 text-center text-(length:--font-md)! text-[#AAAAAA]">
                        Natureza de acompanhamentos - Top 3
                    </h3>
                    <SentryEchart
                        className="flex-1 min-h-0 w-full"
                        option={topTrackingNaturesChart}
                    />
                </article>
            </section>
        </DashCard>
    )
}
